import { useSelector } from "react-redux";
import { reportScreensMap } from "../../components/ReportScreens/ReportScreens";
export default function Reports() {
  const activeReport = useSelector(
    (state) => state?.dashboardActivePage?.activeReport
  );
  // map a screen to a component
  const ReportComponent = reportScreensMap[activeReport];
  if (!ReportComponent) {
    return <div>Report not found: {activeReport}</div>;
  }

  return <ReportComponent />;
}
